import { toast } from "react-toastify";

export const getParametersBody = (params: any) => {
  var formBody = [];
  for (var key in params) {
    var encodedKey = encodeURIComponent(key);
    var encodedValue = encodeURIComponent(params[key]);
    formBody.push(encodedKey + "=" + encodedValue);
  }
  formBody.push(formBody.join("&"));
  console.log("asdfsdafas" + formBody);
  return formBody;
};

export const getParametersBodyContain = (params: any) => {
  let postHeader = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(params),
  };
  return postHeader;
};

export const getParametersHeaderPost = (params: any) => {
  let postHeader = {
    method: "POST",
    body: {},
    headers: { ...params },
  };
  return postHeader;
};

export const getParametersHeaderPut = (params: any) => {
  return {
    method: "PUT",
    body: {},
    headers: {
      ...params,
    },
  };
};

export const getConvertedHeader = (data: any) => {
  let postHeader = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
    body: data,
  };
  return postHeader;
};

export const getConvertedFormDataHeader = () => {
  return {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };
};

export const getConvertedFileUploadHeader = (token: any) => {
  let postHeader = {
    method: "POST",
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: token === undefined ? "null" : "Bearer " + token,
    },
    source: "app",
  };
  return postHeader;
};

export const getConvertedParams = (endUrl: any, params: any) => {
  var lastChar = endUrl.substr(endUrl.length - 1);
  if (lastChar !== "?") {
    endUrl = endUrl + "?";
  }
  Object.keys(params).map((key) => {
    endUrl =
      endUrl +
      encodeURIComponent(key) +
      "=" +
      encodeURIComponent(params[key]) +
      "&";
  });
  endUrl = endUrl.slice(0, -1);
  // console.log("endUrl", endUrl);
  return endUrl;
};

export const getConvertedHeaderGet = (token: any) => {
  let getHeader = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: token === undefined ? "null" : `${token}`,
    },
  };
  return getHeader;
};

export const getConvertedHeaderPOST = (token: any) => {
  let postHeader = {
    method: "POST",
    headers: {
      Accept: "*/*",
      "Content-Type": "application/json",
      Cookie:
        "sails.sid=s%3A13cLNY-5FX_Zkj4rtveW6Ei1QxoC9b9x.vAb1vGliWrdxiXxAHtbp0PuWU8%2FGTzL5m1GCXR%2F4bMU",
      Authorization: token === undefined ? "null" : `Bearer ${token}`,
    },
  };
  return postHeader;
};

export const isEmptyString = (str: any) => !str || str.length === 0;

export const isEmptyObject = (obj: any) =>
  !(obj && Object.keys(obj).length > 0);

export interface TenantsObject {
  id: string;
  name: string;
}

// Toast error and success messages

export const Success = (msg: any) =>
  toast.success(msg, {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light",
  });

export const Error = (err: any) =>
  toast.error(err, {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light",
  });

// Check the user is authorized or not

export const isAuthorized = () => {
  const user: any = localStorage.getItem("userDetails");
  const userToken = JSON.parse(user);
  let authorized;
  if (userToken?.token != null) {
    authorized = true;
  } else {
    authorized = false;
  }
  return authorized;
};

// Roles

export enum Roles {
  TEACHER = "teacher",
  STUDENT = "user",
  ADMIN = "admin",
  OWNER = "owner",
}

// common api response

export interface apiresponseType {
  data: {} | [] | string | null;
  error: string | null;
  message: string | null;
  status: boolean;
  statusCode: number;
}

// apiResponseInitialState Object

export const apiResponseInitialState = {
  data: {} || [] || "" || null,
  error: "" || null,
  message: "",
  status: false,
  statusCode: 0,
};

// Badge constant details

export const Gold = 1;
export const Silver = 2;
export const Bronze = 3;

// Update locally stored data properties

export enum UserDetailsKey {
  token = "token",
  role = "role",
  userId = "userId",
  name = "name",
  email = "email",
  gold = "gold",
  silver = "silver",
  bronze = "bronze",
  energyPoints = "energyPoints",
  profileImage = "profileImage",
  cartCount = "cartCount",
  school = "school",
  gender = "gender",
  standard = "standard",
  city = "city",
  country = "country",
}

export enum HomePageDetailsKey {
  bannerDetails = "bannerDetails",
  courseDetails = "courseDetails",
  promoDetails = "promoDetails",
}

export enum LocalStorageKey {
  UserDetails = "userDetails",
  HomePageDetails = "homePageDetails",
  LoginData = "loginData",
}

// get the locally stored single data using this function

export const getLocalyStoredSingleData = (
  key: LocalStorageKey,
  param: UserDetailsKey | HomePageDetailsKey,
): any => {
  const storedDataString = localStorage.getItem(key);

  if (storedDataString !== undefined && storedDataString !== null) {
    const storedData = JSON.parse(storedDataString);

    if (Array.isArray(storedData)) {
      for (const item of storedData) {
        if (Object.keys(item).includes(param)) {
          return item[param];
        }
      }
    } else {
      return storedData[param];
    }
  }
  return null;
};

// get the locally stored full data using this function

export const getLocallyStoredData = (key: LocalStorageKey) => {
  const locallyStordeData = localStorage.getItem(key);
  if (locallyStordeData !== undefined && locallyStordeData !== null) {
    const parsedData = JSON.parse(locallyStordeData);
    return parsedData;
  }
  return null;
};

// Update the locally stored data
export const updateLocallyStoredData = (
  key: LocalStorageKey,
  updatedObject: any,
): void => {
  const locallyStoredData = localStorage.getItem(key);
  if (locallyStoredData !== undefined && locallyStoredData !== null) {
    const parsedData = JSON.parse(locallyStoredData);
    const mergedData = Object.assign({}, parsedData, updatedObject);
    localStorage.setItem(key, JSON.stringify(mergedData));
  }
};

// update the locally stored single data using this function
export const updateLocallyStoredSingleData = (
  key: LocalStorageKey,
  param: UserDetailsKey | HomePageDetailsKey,
  updatedValue: any
): void => {
  const locallyStoredData = localStorage.getItem(key);
  if (locallyStoredData !== undefined && locallyStoredData !== null) {
    const parsedData = JSON.parse(locallyStoredData);
    
    parsedData[param] = updatedValue;
    
    localStorage.setItem(key, JSON.stringify(parsedData));
  } else {
    localStorage.setItem(key, JSON.stringify({ [param]: updatedValue }));
  }
};

